export type OverrideNavigation = {
  overrideNavigation?: boolean;
  onNavigationOverride?: () => void;
};

export enum AuthV2ErrorCodes {
  AUTHENTICATION_SESSION_NOT_FOUND = 'AUTHENTICATION_SESSION_NOT_FOUND',
}

export type Retry = { retry?: boolean };
